import { useRef, useState } from 'react';
import useClickOutside from '../../hooks/useClickOutside';
import './WorkspaceHomeButton.scss';
import { t } from '../../i18n/i18n';
import ArrowDropdown from '../../assets/dashboard/ArrowDropdown';
import ModalCustom from '../ModalCustom/ModalCustom';
import { determineIconType } from '../../utils/determineIconWorkspace/determineIconWorkspace';
import useDropdownAnimation from '../../hooks/useDropdownAnimation';
import { useWorkspaceManager } from '../../hooks/useWorkspaceManager';
import WorkspaceDropdownContent from '../WorkspaceDropdownContent/WorkspaceDropdownContent';

const WorkspaceHomeButton = () => {
  const workspaceManager = useWorkspaceManager();
  const [open, setOpen] = useState(false);
  const { visible, animationClass, handleToggle, handleClose } = useDropdownAnimation(
    open,
    setOpen,
    'workspace-home-enter',
    'workspace-home-exit'
  );

  const ref = useRef(null);
  useClickOutside(ref, () => handleClose());

  return (
    <>
      {workspaceManager.showModalAddWorkspace && (
        <ModalCustom
          datatestid="modal-create-workspace"
          datatestidbuttonok="button-ok"
          title={t('CREATE_WORKSPACE')}
          htmlSubtitle
          show={workspaceManager.showModalAddWorkspace}
          setShow={workspaceManager.setShowModalAddWorkspace}
          onOkText={t('CREATE')}
          onCancelText={t('CANCEL')}
          onCancel={() => workspaceManager.setShowModalAddWorkspace(false)}
          onOk={workspaceManager.handleCreateWorkspace}
          classModal="modal-create-workspace"
          showCross={false}
          isLoading={workspaceManager.createWorkspaceLoader}
          input={
            <input
              ref={(ref) => ref && ref.focus()}
              className="input-name-workspace input outline-none px-3 py-2  input-search text-base mx-auto mt-3 mb-2"
              onChange={(e) => workspaceManager.setWorkspaceName(e.target.value)}
              type="text"
              value={workspaceManager.workspaceName}
              placeholder={t('CREATE_WORKSPACE_INPUT_NAME')}
            />
          }
        />
      )}
      <div ref={ref} className="workspace-home-button-wrapper position-relative">
        <button
          onClick={handleToggle}
          className="workspace-home-button complete-profile-button font-weight-500 text-sm custom-border-end justify-content-center align-items-center d-flex flex-row py-2 bg-transparent outline-none cursor-pointer"
          style={{ color: '#FFFFFF' }}
          data-testid="workspace-home-button"
        >
          <div className="workspace-home-icon">{determineIconType(workspaceManager.workspaceInfo)}</div>
          <span className="workspace-home-name ml-2 mr-1">
            {workspaceManager.workspaceInfo.placeholder}
          </span>
          <div
            className={`${open ? 'workspace-home-arrow-open' : 'workspace-home-arrow'}`}
          >
            <ArrowDropdown />
          </div>
        </button>
        {visible && (
          <WorkspaceDropdownContent
            worskpacesListFilter={workspaceManager.worskpacesListFilter}
            searchWorkspace={workspaceManager.searchWorkspace}
            setSearchWorkspace={workspaceManager.setSearchWorkspace}
            setWorkspace={workspaceManager.setWorkspace}
            addFavorite={workspaceManager.addFavorite}
            removeFavorite={workspaceManager.removeFavorite}
            createWorkspace={workspaceManager.createWorkspace}
            redirectToConfig={workspaceManager.redirectToConfig}
            dropdownClassName={`workspace-home-dropdown position-absolute ${animationClass}`}
            onClose={handleClose}
            currentWorkspaceId={workspaceManager.currentWorkspace}
          />
        )}
      </div>
    </>
  );
};

export default WorkspaceHomeButton;
